(ns kyber.kyber-db.content-provider-tag)

(def model
  {:ident-key
   :content-provider.tag/uuid

   :schema
   #:content-provider.tag
   {:uuid
    {:doc "UUID of a tag"}

    :name
    {:doc "Name of the tag"}}})
